/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-news-card.vue?vue&type=template&id=9250c804&scoped=true"
import script from "./pc-news-card.vue?vue&type=script&lang=js"
export * from "./pc-news-card.vue?vue&type=script&lang=js"
import style0 from "./pc-news-card.vue?vue&type=style&index=0&id=9250c804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9250c804",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard});
